import axios from "axios";

//默认配置
const config = {
  baseURL: process.env.VUE_APP_BASE_HOST,
  // 设置超时时间
  timeout: 30 * 1000,
};

// 创建实例
const service = axios.create(config);

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default service;
